import { render } from "./App.vue?vue&type=template&id=d0e086b0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d0e086b0&lang=css"

import exportComponent from "/root/workspace/youyi_1_tob-teacher-fe_Ff2X/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__